import { render, staticRenderFns } from "./SmsNotificationView.vue?vue&type=template&id=080d8322"
import script from "./SmsNotificationView.vue?vue&type=script&lang=js"
export * from "./SmsNotificationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports